export enum MessageRole {
  System = "system",
  User = "user",
  Assistant = "assistant",
}
